import { render, staticRenderFns } from "./EditWechatDialog.vue?vue&type=template&id=44aa8337&scoped=true"
import script from "./EditWechatDialog.vue?vue&type=script&lang=js"
export * from "./EditWechatDialog.vue?vue&type=script&lang=js"
import style0 from "./EditWechatDialog.vue?vue&type=style&index=0&id=44aa8337&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44aa8337",
  null
  
)

export default component.exports